/**
 * Default build type
 * Change this value when developing locally to test the different environments
 * Values:
 *  - "production"
 *  - "staging"
 *  - "uat"
 * @default "uat"
 * @note If on localhost
 * @default "production"
 * @note If from pipeline, note that pipeline variables should override this
 *
 */
const defaultBuildType =
  process.env.NODE_ENV !== "production" ? "uat" : "production";
const PARSED_REACT_APP_BUILD_TYPE = (
  process.env.REACT_APP_BUILD_TYPE ?? defaultBuildType
).toLowerCase();

// QUESTION: Should we move these URLs to appropriate `.env` files
// e.g. `.env.production`, `.env.staging`, `.env.uat`, etc.
let BASE_URL: string;
let STORAGE_URL: string;
let isProduction: boolean = false;
// IDEA: Hardcoded token is not ideal, it could come from a deployment pipeline
// variable; the injected variable would need to be passed into this (as this
// appears to be loaded as an iframe)
// SEE: MAPBOX_TOKEN (across other repos)
const MAPBOX_TOKEN =
  "pk.eyJ1IjoiZHJvbmVhZyIsImEiOiJjbW9sanFsazAwMHJkMzRxeDFzeXVkd3I5In0.617JlBuikXF5PMpVXpGcvQ";

switch (PARSED_REACT_APP_BUILD_TYPE) {
  case "production":
    BASE_URL = "https://skippy-web-clientmanagement-api.skippy.farm";
    STORAGE_URL = "https://sphere.skippy.farm/";
    isProduction = true;
    break;
  case "staging":
    BASE_URL = "https://skippy-web-clientmanagement-api-staging.skippy.farm";
    STORAGE_URL = "https://skippyscoutappstaging.z33.web.core.windows.net/";
    break;
  case "uat":
  default:
    BASE_URL = "https://skippy-web-clientmanagement.api.avamae.co.uk";
    STORAGE_URL = "https://uatblobstorage2019.z16.web.core.windows.net/";
    break;
}

export { isProduction, BASE_URL, STORAGE_URL, MAPBOX_TOKEN };

/**
 * Endpoints for API calls
 */
export const endpoints = {
  auth: {},
  farmDetails: {
    /**
     * Get farm details and list of fields
     * @method GET
     */
    getPanoFields: "/api/v1/publicrole/fieldreportmodule/getpanofields",
  },
  fieldDetails: {
    /**
     * Get field details, includes more data on the "current field" as well as
     * more information on neighbouring fields
     * @method GET
     */
    getKrpanoField: "/api/v1/publicrole/fieldreportmodule/getkrpanofield",
  },
  features: {
    /**
     * Converts ath and atv values from the sphere into coordinates
     * @method GET
     */
    getCoordinates:
      "/api/v1/publicrole/fieldreportmodule/getpositionfromsphere",
    /**
     * Converts ath and atv values from sphere points into a measured distance
     * @method POST
     */
    measure: "/api/v1/publicrole/fieldreportmodule/getdistance",
    /**
     * Add a new POI to the field
     * @method POST
     */
    createPoi:
      "/api/v1/publicrole/fieldreportmodule/addscoutpointclicklocation",
    /**
     * Remove a POI from the field
     * @method POST
     */
    deletePoi: "/api/v1/publicrole/fieldreportmodule/removescoutpoint",
    /**
     * Get the latest calibration values for the panorama
     * @method GET
     */
    getCalibration: "/api/v1/publicrole/fieldreportmodule/getimagecalibration",
    /**
     * Set the new calibration values for the panorama
     * @method POST
     */
    setCalibration: "/api/v1/publicrole/fieldreportmodule/setimagecalibration",
    /**
     * Get Overpass API layers for the panorama
     * @method GET
     */
    getLayer: "/api/v1/publicrole/fieldreportmodule/spheremapfeatures",
  },
  // ...
};

// NOTE: set boundary - appears to be unused even in old UI
// Geometry_Or_Point_List_Required
// Provide_Geometry_OR_Point_List
// At_Least_3_Points_Required
// Invalid_Ath
// Invalid_Atv
